module.exports = __webpack_public_path__ + "img/award (7).b2ec4859.jpg";